import {
  Avatar, Box, Icon, Text,
} from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { animated as a, useSpring } from 'react-spring';
import { graphql, useStaticQuery } from 'gatsby';

import { StarIcon } from '@chakra-ui/icons';
import { generate } from 'shortid';
import GoogleG from '../../assets/Google__G__Logo.svg';

const ReviewWidget = () => {
  // interval for google review widget
  const [intervalLen, setIntervalLen] = useState(6000);
  const [show, setShow] = useState(true);
  const { googleReviews } = useStaticQuery(query);
  const styles = useSpring({
    position: 'fixed',
    left: '10px',
    zIndex: '100',
    opacity: show ? 1 : 0,
    bottom: show ? '10px' : '-300px',
  });

  useEffect(() => {
    if (process.env.NODE_ENV.trim() === 'production') {
      const interval = setTimeout(() => {
        setShow(!show);
      }, intervalLen);
      return () => clearTimeout(interval);
    }
  }, [show]);

  const review = googleReviews.nodes[Math.floor(Math.random() * googleReviews.nodes.length)];
  return (
    <a.div style={styles}>
      <Box
        zIndex="100"
        width="15rem"
        height="6rem"
        rounded="md"
        p={5}
        backgroundColor="white"
        boxShadow="xl"
        display="flex"
        flexDirection={{ base: 'row' }}
        alignItems="center"
      >
        <Box
          flexBasis={{ base: '20%' }}
          display="flex"
          flexDir="column"
          justifyContent="space-between"
        >
          <Avatar
            size="sm"
            name={`Google profile of ${review.author_name}`}
            src={review.profile_photo_url}
          />
          {' '}
        </Box>
        <Box flexBasis={{ base: '80%' }}>
          <Box
            mb={1}
            display="flex"
            alignItems="center"
          >
            <Box mr={2}>
              <GoogleG style={{ width: '10px', height: '10px' }} />
            </Box>
            {Array.from({ length: review.rating }, () => 0).map((j) => (
              <Icon
                key={generate()}
                as={StarIcon}
                boxSize={3}
                color="yellow.300"
              />
            ))}
          </Box>
          <Text
            mb={1}
            fontSize="xs"
            as="em"
            noOfLines="2"
          >
            {review.text}
          </Text>
          <Text
            variant="sec"
            fontSize="xs"
          >
            -
            {' '}
            {review.author_name}
          </Text>
        </Box>
      </Box>
    </a.div>
  );
};

export const query = graphql`
  query {
    googleReviews: allGooglePlacesReview {
      nodes {
        author_url
        author_name
        googlePlacesId
        rating
        profile_photo_url
        time
        relative_time_description
        text
        id
      }
    }
  }
`;

export default ReviewWidget;
